// Centralized API configuration
// In development, this defaults to localhost:5000
// In production, you can set REACT_APP_API_URL as an environment variable
const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
    ? 'http://localhost:5000' 
    : '');

export default API_BASE_URL;
